class Modal {

    constructor() {
		this.modalButton = document.querySelector('.js-modal-counties')
		this.modalContent = document.querySelector('.js-modal-counties-content')
		this.modalContentClose = document.querySelector('.js-modal-counties-content-close')
    }
  
    init() {
      this.events()
    }
  
    events() {

		if ( this.modalButton ) {
			
			this.modalButton.addEventListener('click', () => {
				this.openModal()
			})

			this.modalContentClose.addEventListener('click', () => {
				this.closeModal()
			})

		}
  
    }

	openModal() {
		this.modalContent.classList.add('show')
	}

	closeModal() {
		this.modalContent.classList.remove('show')
	}    

  }
  
  export default Modal
  